import React from 'react';
import PropTypes from 'prop-types';

class FilterGamesWeek extends React.Component {
  constructor(props) {
    super(props);
    this.state = {gameWeekNumber: props.initialValue};
  }

  handleChange(event) {
    const {multiple} = this.props.selectProps;

    let gamesWeek = multiple ? [] : null;
    if (multiple) {
      const {options} = event.target;
      for (let i = 0, l = options.length; i < l; i++) {
        if (options[i].selected) {
          gamesWeek.push(options[i].value);
        }
      }
    } else {
      gamesWeek = event.target.value;
    }

    this.setState({gamesWeek});
    this.props.onChange(gamesWeek);
  }

  render() {
    const {label, options, selectProps} = this.props;
    const selectName = 'gamesWeek-filter';
    return (
      <div className="gamesWeek-filter inline">
        {label && [
          <label key="gamesWeek-filter-label-1" htmlFor={selectName}>
            {label}
          </label>,
          <br key="gamesWeek-filter-label-2" />,
        ]}
        <select
          name={selectName}
          className="form-control"
          disabled={options.length < 1}
          onChange={this.handleChange.bind(this)}
          value={this.state.gameWeekNumber}
          {...selectProps}>
          {options.map(({value, text, ...rest}) => (
            <option key={value} value={value} {...rest}>
              {text}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

FilterGamesWeek.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  selectProps: PropTypes.object,
};

FilterGamesWeek.defaultProps = {
  initialValue: undefined,
  options: [],
  selectProps: {},
};

export default FilterGamesWeek;



// WEBPACK FOOTER //
// ./src/components/Filters/GamesWeek/index.js